import { LabelsTranslations } from './zh';

export const labelsEn: LabelsTranslations = {
  // Page Title
  title: 'Label Management',
  
  // Actions
  generateLabels: 'Generate Labels',
  generate: 'Generate',
  print: 'Print',
  downloadLabel: 'Download Label',
  printSuccess: 'Print successful',
  
  // Template Types
  template: 'Template',
  compact: 'Compact',
  standard: 'Standard',
  detailed: 'Detailed',
  
  // Settings
  size: 'Size',
  printCount: 'Print Count',
  selectPrinter: 'Select Printer',
  
  // Status
  selected: 'Selected',
};

